enum Status {
    PENDING = 'Pending',
    DOWNLOADING = 'Downloading',
    PAUSED = 'Paused',
    PROCESSING = 'Processing',
    DOWNLOADED = 'Downloaded',
}

export default Status;